import type { MainSelection } from '../typings'

import { mainAtom } from '../main'

export const resetMainSelection = (category: keyof MainSelection) => {
  mainAtom.selection[category] = []
  return mainAtom.selection[category]
}
